export default __webpack_public_path__ + "group-11.svg";